import { Component } from 'react';
import { Box } from '@mui/material';

import { ucfirst, clone } from '../../core/utils';
import { setConfig } from '../../core';
import { PlanningCycleWorkbench as MainPanel} from '../custom/planningcycle';

export class PlanningCycle extends Component<any,any> {
  constructor(props:any) {
    super(props);
  }

  configuration = () => {
    const config = {
      service:{
        name:'planningcycle',
        title:'Planning Cycle',
        fields:[],
        grid: [],
        menu: {},
        eform:[],
      },
      create:false,
      actions: {start:'Load'},
      panels: {start:'custom'},
    };
    return config;
  }

  render = () => {
    const {
      service,
      setHome,
      setPage,
      onParam,
      showNotification,
      actionSet,
      rowActions,
      userData,
      params,
      ...others
    } = this.props;

    const conf = this.configuration();
    const customconfig = setConfig(conf); 

    const serviceconfig = clone(customconfig);
    const servicedata = serviceconfig.service;
    const title = ucfirst(servicedata.title || service);

    return (
      <Box>
        <MainPanel
          service={service}
          rowActions={rowActions}
          userData={userData}
          title={title}
          sconfig={serviceconfig}
          actionSet={actionSet}
          params={params}
          setHome={setHome}
          setPage={setPage}
          onParam={onParam}
          {...others}
        />
      </Box>
    );
  };
}

export default PlanningCycle;
